import React from 'react';
export function ScheduleTable() {
  const classes = [{
    name: 'Mini Troopers (Ages 3-5)',
    days: 'Monday – Friday',
    time: '4:30 PM – 5:00 PM'
  }, {
    name: 'Kids Taekwondo (Ages 6+)',
    days: 'Monday – Friday',
    time: '5:00 PM – 6:00 PM'
  }, {
    name: 'Kids Taekwondo (Ages 6+)',
    days: 'Monday – Friday',
    time: '6:00 PM – 7:00 PM'
  }, {
    name: 'Family Class',
    days: 'Monday – Friday',
    time: '6:00 PM – 7:00 PM'
  }, {
    name: 'Competition Team',
    days: 'Saturday',
    time: '7:00 PM – 9:00 PM'
  }];
  return <div className="bg-paper rounded-2xl shadow-soft border border-subtle-gray overflow-hidden" data-id="element-417">
      <div className="bg-ink p-6 text-center" data-id="element-418">
        <h3 className="text-2xl text-white m-0" data-id="element-419">Current Class Schedule</h3>
      </div>
      <div className="divide-y divide-subtle-gray" data-id="element-420">
        {classes.map((cls, idx) => <div key={idx} className="p-6 flex flex-col md:flex-row md:items-center justify-between gap-4 hover:bg-off-white transition-colors" data-id="element-421">
            <div className="flex-1" data-id="element-422">
              <h4 className="text-xl text-ink mb-1" data-id="element-423">{cls.name}</h4>
              <p className="text-gray-warm font-medium" data-id="element-424">{cls.days}</p>
            </div>
            <div className="bg-subtle-gray/50 px-4 py-2 rounded-lg text-ink font-bold text-lg whitespace-nowrap" data-id="element-425">
              {cls.time}
            </div>
          </div>)}
      </div>
      <div className="p-6 bg-off-white text-center border-t border-subtle-gray" data-id="element-426">
        <p className="text-sm text-gray-warm font-medium" data-id="element-427">
          * Class times may change. Storm will confirm the best class time when
          you sign up.
        </p>
      </div>
    </div>;
}